import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ShippingService } from '../../services/api-services/shipping.service';
@Component({
  selector: 'app-update-request-status',
  templateUrl: './update-request-status.component.html',
  styleUrl: './update-request-status.component.scss'
})
export class UpdateRequestStatusComponent {
  isLoading: boolean = false;
  constructor(public dialogRef: MatDialogRef<UpdateRequestStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public toastr: ToastrService,
    private shippingService: ShippingService,
  ) {
  }

  closeDialog() {
    this.dialogRef.close(false);
  }

  submitForm() {
    this.isLoading = true;
    const payload = {
      "order_id": this.data?.item?.order_id,
      "status_id": this.data?.item?.status
    }
    this.shippingService.update_req_status(payload).subscribe({
      next: (res) => {
        if (res?.body?.success) {
          this.toastr.success(res?.body?.message);
          this.dialogRef.close(res?.body?.success);
          this.isLoading = false;
        } else {
          this.toastr.error(res?.body?.message || 'Failed to update status', 'Error');
          this.dialogRef.close(false);
          this.isLoading = false;
        }
      },
      error: (err) => {
        console.error('error::', err);
        this.toastr.error(err?.message || 'Failed to update status', 'Error');
        this.dialogRef.close(false);
        this.isLoading = false;
      }
    })
  }

}
